import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../../config";

export default function EditRound() {
  const { id } = useParams();
  const navigate = useNavigate();



  const token = localStorage.getItem("token");
  const user_id = localStorage.getItem("userId");

  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");

  const [formData, setFormData] = useState({
    title: "",
    price: "",
    total_cut_value: "",
    yearly_revenue: "",
    clients_count: "",
    suburb: "",
    state: "",
    postcode: "",
    description: "",
  });

  // GET ROUND DATA
  useEffect(() => {
    async function loadRound() {
      try {
        const res = await axios.get(`${API_BASE_URL}/api/lawn-mowing/rounds/${id}`);

        if (res.data.success) {
          const l = res.data.listing;
          setFormData({
            title: l.title,
            price: l.price,
            total_cut_value: l.total_cut_value,
            yearly_revenue: l.yearly_revenue,
            clients_count: l.clients_count,
            suburb: l.suburb,
            state: l.state,
            postcode: l.postcode,
            description: l.description,
          });
        } else {
          setMessage("❌ Failed to load listing data");
        }

        setLoading(false);
      } catch (err) {
        console.error("Error loading round:", err);
        setMessage("❌ Server error loading round");
        setLoading(false);
      }
    }

    loadRound();
 }, [id, API_BASE_URL]);

  // INPUT HANDLER
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // SAVE EDITED ROUND
  const handleSave = async (e) => {
    e.preventDefault();
    setMessage("");

    try {
      const payload = {
        user_id,
        ...formData,
        enquiry_only: 1,
        badge: null,
        status: "active",
      };

      const res = await axios.put(
        `${API_BASE_URL}/api/lawn-mowing/rounds/edit/${id}`,
        payload,
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (!res.data.success) {
        setMessage(`❌ ${res.data.error || "Failed to update listing"}`);
        return;
      }

      setMessage("✅ Round updated successfully!");

      // SAME BEHAVIOUR AS EditListing.jsx → redirect to My Listings
      setTimeout(() => navigate("/my-listings"), 600);
    } catch (err) {
      console.error("Error saving:", err);
      setMessage("❌ Server error saving changes");
    }
  };

  if (loading) return <p style={{ padding: "20px" }}>Loading round...</p>;

  // ---------- UI STYLING (MATCHES EditListing.jsx) ----------
  const container = {
    maxWidth: "95%",
    width: "600px",
    margin: "50px auto",
    padding: "25px",
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0 4px 15px rgba(0,0,0,0.15)",
  };

  const headerTitle = {
    textAlign: "center",
    marginBottom: "25px",
    color: "#2e7d32",
  };

  const formStyle = {
    display: "flex",
    flexDirection: "column",
    gap: "18px",
  };

  const inputStyle = {
    padding: "10px",
    borderRadius: "6px",
    border: "1px solid #ccc",
  };

  const boldLabel = { fontWeight: "bold" };

  const sectionHeader = {
    borderBottom: "2px solid #4caf50",
    paddingBottom: "5px",
    marginTop: "10px",
  };

  const buttonStyle = {
    marginTop: "20px",
    padding: "15px",
    backgroundColor: "#4caf50",
    color: "#fff",
    fontWeight: "bold",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "1rem",
  };

  return (
    <div style={container}>
      <h2 style={headerTitle}>Edit Round Listing</h2>

      {message && (
        <div
          style={{
            marginBottom: "20px",
            textAlign: "center",
            color: message.includes("❌") ? "#d32f2f" : "#2e7d32",
            fontWeight: 600,
          }}
        >
          {message}
        </div>
      )}

      <form onSubmit={handleSave} style={formStyle}>
        <h3 style={sectionHeader}>Round Information</h3>

        <label style={boldLabel}>Title:</label>
        <input
          style={inputStyle}
          name="title"
          value={formData.title}
          onChange={handleChange}
          required
        />

        <label style={boldLabel}>Price ($):</label>
        <input
          type="number"
          style={inputStyle}
          name="price"
          value={formData.price}
          onChange={handleChange}
          required
        />

        <label style={boldLabel}>Total Cut Value ($):</label>
        <input
          type="number"
          style={inputStyle}
          name="total_cut_value"
          value={formData.total_cut_value}
          onChange={handleChange}
        />

        <label style={boldLabel}>Yearly Revenue ($):</label>
        <input
          type="number"
          style={inputStyle}
          name="yearly_revenue"
          value={formData.yearly_revenue}
          onChange={handleChange}
          required
        />

        <label style={boldLabel}>Clients Count:</label>
        <input
          type="number"
          style={inputStyle}
          name="clients_count"
          value={formData.clients_count}
          onChange={handleChange}
          required
        />

        <h3 style={sectionHeader}>Location</h3>

        <label style={boldLabel}>Suburb:</label>
        <input
          style={inputStyle}
          name="suburb"
          value={formData.suburb}
          onChange={handleChange}
          required
        />

        <label style={boldLabel}>State:</label>
        <select
          style={inputStyle}
          name="state"
          value={formData.state}
          onChange={handleChange}
          required
        >
          <option value="">Select State</option>
          <option value="VIC">VIC</option>
          <option value="NSW">NSW</option>
          <option value="QLD">QLD</option>
          <option value="SA">SA</option>
          <option value="WA">WA</option>
          <option value="TAS">TAS</option>
          <option value="NT">NT</option>
          <option value="ACT">ACT</option>
        </select>

        <label style={boldLabel}>Postcode:</label>
        <input
          style={inputStyle}
          name="postcode"
          value={formData.postcode}
          onChange={handleChange}
        />

        <h3 style={sectionHeader}>Description</h3>

        <textarea
          style={{ ...inputStyle, minHeight: "120px" }}
          name="description"
          value={formData.description}
          onChange={handleChange}
          required
        />

        <button type="submit" style={buttonStyle}>
          Save Changes
        </button>
      </form>
    </div>
  );
}
